"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Listener {
    constructor() {
        this.listeners = [];
    }
    on(t) {
        this.listeners.push(t);
    }
    off(t) {
        const idx = this.listeners.findIndex((tt) => tt === t);
        if (idx !== -1) {
            this.listeners.splice(idx, 1);
        }
    }
    fire(t) {
        this.listeners.forEach((l) => l(t));
    }
    clear() {
        this.listeners = [];
    }
}
exports.default = Listener;
//# sourceMappingURL=Listener.js.map